// extracted by mini-css-extract-plugin
export default {"band":"Band_band__c3PIt","a":"Band_a__CgQBW"};